import React from "react";
import { useNavigate } from "react-router-dom";
import {Clip, FourPointStar, CrookedStar} from "../../../assets";

const ResultCard = ({ level, score, placementResultId }) => {
  const navigate = useNavigate();

  const openReadinessFromPlacement = () => {
    if (!placementResultId) {
      navigate("/readiness-checker");
      return;
    }

    navigate(`/readiness-checker/placement-intro?placement_result_id=${placementResultId}`);
  };

  const normalizedLevel = level ? level.toLowerCase() : "";
  const levelLabel = normalizedLevel ? normalizedLevel.toUpperCase() : "-";

  const levelTextColor =
    normalizedLevel === "beginner"
      ? "text-[#1A7A3A]"
      : normalizedLevel === "intermediate"
        ? "text-[#FFCC3A]"
        : normalizedLevel === "advanced"
          ? "text-[--st-color-program-red]"
          : "text-[#1D8A3C]";

  const levelTextSize =
    normalizedLevel === "intermediate"
      ? "text-[34px] sm:text-[70px] md:text-[76px]"
      : "text-[42px] sm:text-[70px] md:text-[96px]";

  return (
    <div className="relative z-10 mx-auto w-full max-w-6xl rounded-[34px] border-[14px] border-[#FFCC3A] bg-[#FFCC3A] p-4 sm:p-5 shadow-[0_18px_32px_rgba(0,0,0,0.12)]">
      <img
        src={Clip}
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute right-5 top-[1px] z-20 h-20 w-auto rotate-10 sm:right-8 sm:top-[-4px] sm:h-24 md:right-10 md:top-26 md:h-32"
        loading="lazy"
      />

      <div className="relative z-10 overflow-visible rounded-[30px] bg-[#FFFDF9] px-4 py-6 sm:px-8 sm:py-8 md:px-10 md:py-10">
        {/* Decorative dots */}
        <div className="mb-4 flex items-center justify-between gap-4 px-2 sm:px-6 md:px-10">
          {Array.from({ length: 9 }).map((_, index) => (
            <span key={index} className="h-6 w-6 rounded-full bg-[#FFCE43] sm:h-8 sm:w-8" />
          ))}
        </div>

        {/* Stars: placed above white paper but behind the text. Keep original top/right/left positions. */}
        <img
          src={FourPointStar}
          alt=""
          aria-hidden="true"
          className="pointer-events-none absolute left-[38px] top-[80px] z-10 hidden w-[96px] sm:block lg:left-[28px] lg:w-[116px]"
          loading="lazy"
        />
        <img
          src={CrookedStar}
          alt=""
          aria-hidden="true"
          className="pointer-events-none absolute right-[1px] top-[200px] z-10 hidden w-[126px] sm:block lg:right-[35px] lg:w-[128px]"
          loading="lazy"
        />

        <div className="mx-auto max-w-5xl text-center relative z-20">
          <h2 className="text-[32px] font-extrabold tracking-tight text-[#4A4A4A] sm:text-[44px] md:text-[56px]">
            Hasil Tes Kamu
          </h2>

          <div className={`mt-3 font-extrabold leading-none tracking-tight ${levelTextSize} ${levelTextColor}`}>
            {levelLabel}!
          </div>

          <p className="mt-6 text-[22px] leading-tight text-[#4E4E4E] sm:text-[34px] md:text-[44px]">
            Score kamu : <span className="font-extrabold text-[#303030]">{score} Correct!</span>
          </p>

          <button
            type="button"
            onClick={openReadinessFromPlacement}
            className="st-btn-base bg-[#1A7A3A] mt-6 w-full max-w-[680px] px-6 py-4 text-[16px] sm:text-[22px] md:text-[26px] text-[#FFFFFF]"
          >
            Kembali ke Readiness Checker
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResultCard;
